import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";

import { PreChatHeader } from "../../../../components";
import { types } from "../../definitions";
import BlockRenderer from "../../../../components/blockRenderer";

const PreChat = ({
  anchorProps,
  blocks,
  hasImage,
  headerText,
  loading,
  subText,
}: types.PreChatProps): ReactElement => {
  return (
    <Box overflowY={"auto"} position={"relative"}>
      <PreChatHeader
        hasImage={hasImage}
        headerText={headerText}
        subText={subText}
        anchorProps={anchorProps}
      />
      {/** Recommended Prompts */}
      <BlockRenderer blocks={blocks} />
    </Box>
  );
};

export default PreChat;
